// extracted by mini-css-extract-plugin
export default {"text":"css_text__Z5-dV","buttonsRow":"css_buttonsRow__63GSw","button":"css_button__dC+7k"};